import { Avatar, Clickable, Col, Icon, Row, Text } from 'components';
import { theme } from 'lib';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { SubSettings } from './';

const SubscriptionItem = ({ item }) => {
  const { subscribed, recurring, type } = item;

  const [subSettingsVisible, setSubSettingsVisible] = useState(false),
    navigate = useNavigate(),
    { t } = useTranslation(),
    isBundle = type === 'bundle';

  return (
    <React.Fragment>
      <Row noFlex center marg="0 0 12px" between>
        <Row noFlex center between wid="100%">
          <Clickable onClick={() => navigate(`/profile/${item.subscribed.username}`)}>
            <Row>
              <Avatar user={item.subscribed} small />

              <Col noFlex marg="0 0 0 12px">
                <Text bold>
                  {isBundle
                    ? t('subscribe.bundleSquad', { name: subscribed.name })
                    : subscribed.name}
                </Text>

                <Text marg="2px 0 0" b2 col={theme.GREY_60} start>
                  {t(`subscribe.${recurring}`)}
                </Text>
              </Col>
            </Row>
          </Clickable>

          <Row center gap="8px">
            <Clickable onClick={() => navigate('/billing')}>
              <Icon type="receipt" col={theme.GREY_60} dimensions={24} />
            </Clickable>

            <Clickable onClick={() => setSubSettingsVisible(true)}>
              <Icon type="closeCircled" col={theme.GREY_60} dimensions={20} />
            </Clickable>
          </Row>
        </Row>
      </Row>

      <SubSettings
        visible={subSettingsVisible}
        handleClose={() => setSubSettingsVisible(false)}
        onUnsubscribe={() => null}
        item={subSettingsVisible && item}
      />
    </React.Fragment>
  );
};

export default SubscriptionItem;
